import { Collapse, CollapseProps, Drawer, Flex, Modal, Tag, Typography } from 'antd';
import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { clearWorkflowCreatePayload, setIsDrawerOpen } from '../../../store/workflows/slice';
import JobInfo from './JobInfo';
import ProductScope from './ProductScope';
import JobTypeAndScheduling from './JobTypeAndScheduling';
import ReviewAndLaunch from './ReviewAndLaunch';
import { clearAllFilters } from '../../../store/products/slice';

const getPanelStyle = (isActive: boolean): React.CSSProperties => ({
  marginBottom: 24,
  background: isActive ? '#FBFCFC' : '#ffffff',
  borderRadius: 20,
  border: isActive ? 'none' : '1px solid #F4F4F4',
  userSelect: 'none',
});

interface StepTagProps {
  stepNumber: number;
  isActive: boolean;
}

const StepTag: React.FC<StepTagProps> = ({ stepNumber, isActive }) => (
  <Tag
    style={
      isActive
        ? { color: '#ffffff', background: '#171717' }
        : { color: '#171717', background: '#F0F0F0' }
    }
  >
    Step {stepNumber}
  </Tag>
);

const getItems = (activeStep: Array<number>): CollapseProps['items'] => [
  {
    key: 1,
    label: (
      <Flex gap={8}>
        Job Info <StepTag stepNumber={1} isActive={activeStep.includes(1)} />
      </Flex>
    ),
    children: <JobInfo />,
    style: getPanelStyle(activeStep.includes(1)),
  },
  {
    key: 2,
    label: (
      <Flex gap={8}>
        Product Scope
        <StepTag stepNumber={2} isActive={activeStep.includes(2)} />
      </Flex>
    ),
    children: <ProductScope />,
    style: getPanelStyle(activeStep.includes(2)),
  },
  {
    key: 3,
    label: (
      <Flex gap={8}>
        Job Type and Scheduling
        <StepTag stepNumber={3} isActive={activeStep.includes(3)} />
      </Flex>
    ),
    children: <JobTypeAndScheduling />,
    style: getPanelStyle(activeStep.includes(3)),
  },
  {
    key: 4,
    label: (
      <Flex gap={8}>
        Review and Launch
        <StepTag stepNumber={4} isActive={activeStep.includes(4)} />
      </Flex>
    ),
    children: <ReviewAndLaunch />,
    style: getPanelStyle(activeStep.includes(4)),
  },
];

const UpsertTaggingWorkflowDrawer = () => {
  const isOpen = useAppSelector(state => state.workflows.isDrawerOpen);
  const dispatch = useAppDispatch();

  const workflowPayload = useAppSelector(state => state.workflows.workflowCreatePayload);

  const [activeStep, setActiveStep] = useState([1]);

  const isEditing = Boolean(workflowPayload && 'id' in workflowPayload && workflowPayload.id);

  const handleClose = () => {
    Modal.confirm({
      title: 'Are you sure you want to close?',
      content: 'Any unsaved changes will be lost.',
      okText: 'Yes, Close',
      cancelText: 'Cancel',
      onOk: () => {
        dispatch(clearWorkflowCreatePayload());

        if (isEditing) {
          dispatch(clearAllFilters());
        }

        dispatch(setIsDrawerOpen(false));
      },
    });
  };

  return (
    <Drawer closable={false} onClose={handleClose} open={isOpen} size="large">
      <Typography.Paragraph
        style={{
          fontSize: '24px',
        }}
      >
        Create Rule
      </Typography.Paragraph>
      <Collapse
        bordered={false}
        activeKey={activeStep}
        onChange={activeKeys => {
          setActiveStep(activeKeys.map(Number));
        }}
        expandIconPosition="right"
        items={getItems(activeStep)}
        ghost
      />
    </Drawer>
  );
};

export default UpsertTaggingWorkflowDrawer;
